import { render, staticRenderFns } from "./AppNotFound.vue?vue&type=template&id=c6af1fe8&scoped=true"
import script from "./AppNotFound.vue?vue&type=script&lang=js"
export * from "./AppNotFound.vue?vue&type=script&lang=js"
import style0 from "./AppNotFound.vue?vue&type=style&index=0&id=c6af1fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6af1fe8",
  null
  
)

export default component.exports